/**
 * Client-level errors that occur before HTTP requests are made.
 * These are distinct from HTTP errors which occur after receiving responses.
 */
export class MissingTokenError extends Error {
    constructor() {
        super('Authentication token is missing or expired');
        this.name = 'MissingTokenError';
    }
}
